import { defineStore } from 'pinia'

import state from './state'
import actions from './actions'

const useNoticesStore = defineStore('notices', {
  state,
  actions
})

export default useNoticesStore
